import React, {Component} from 'react';
import {bool, func, node, string} from 'prop-types';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import styles from './Dialog.scss';


class Dialog extends Component {
  static propTypes = {
    isOpen: bool.isRequired,
    headerText: string,
    onClose: func,
    children: node.isRequired,
    className: string,
  };

  static defaultProps = {
    headerText: 'Modal',
    onClose: () => {},
    className: undefined,
  };

  componentWillMount() {
    ReactModal.setAppElement('body');
  }

  render() {
    const {isOpen, headerText, onClose, children, className} = this.props;
    return (
      <ReactModal
        isOpen={isOpen}
        contentLabel={headerText}
        className={classNames(styles.Dialog, className)}
        overlayClassName={styles.overlay}
        onRequestClose={onClose}
      >
        <div>{children}</div>
      </ReactModal>
    );
  }
}

export default Dialog;
